import { render, staticRenderFns } from "./successNetpay.vue?vue&type=template&id=76122b20&scoped=true&"
import script from "./successNetpay.vue?vue&type=script&lang=js&"
export * from "./successNetpay.vue?vue&type=script&lang=js&"
import style0 from "./successNetpay.vue?vue&type=style&index=0&id=76122b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76122b20",
  null
  
)

component.options.__file = "successNetpay.vue"
export default component.exports